import { useCallback } from 'react';

import { useToastStore } from 'dibs-toaster/exports/useToastStore.ts';
import { ACTION_RESULT_TOAST_PROPS } from 'dibs-toaster/exports/sharedToastProps.ts';

import { AddToFolderToastContent, RemoveFromFolderToastContent } from './FolderToastsContent.tsx';
import { trackItemFavoritingToast } from './tracking.ts';

const useFolderToasts = ({ favoritesPageRedesignFF }: { favoritesPageRedesignFF?: boolean } = {}): {
    addToFolderToast: (portfolio: { portfolioId: string; portfolioName: string }) => void;
    removeFromFolderToast: (portfolio: { portfolioName: string }) => void;
} => {
    const addToast = useToastStore(state => state.add);

    const addToFolderToast = useCallback(
        ({ portfolioId, portfolioName }: { portfolioId: string; portfolioName: string }) => {
            addToast({
                toast: {
                    ...ACTION_RESULT_TOAST_PROPS,
                    children: (
                        <AddToFolderToastContent
                            portfolioId={portfolioId}
                            portfolioName={portfolioName}
                            favoritesPageRedesignFF={favoritesPageRedesignFF}
                        />
                    ),
                },
            });
            trackItemFavoritingToast({ trigger: 'foldered' });
        },
        [addToast, favoritesPageRedesignFF]
    );

    const removeFromFolderToast = useCallback(
        ({ portfolioName }: { portfolioName: string }) => {
            addToast({
                toast: {
                    ...ACTION_RESULT_TOAST_PROPS,
                    children: (
                        <RemoveFromFolderToastContent
                            portfolioName={portfolioName}
                            favoritesPageRedesignFF={favoritesPageRedesignFF}
                        />
                    ),
                },
            });
            trackItemFavoritingToast({ trigger: 'folder removed' });
        },
        [addToast, favoritesPageRedesignFF]
    );

    return {
        addToFolderToast,
        removeFromFolderToast,
    };
};

export { useFolderToasts };
